/* ============================================================
   TU Custom Cart Drawer engine (standalone, theme-agnostic)
   Cart AJAX API only: /cart.js, /cart/add.js, /cart/change.js, /cart/update.js
   + /recommendations/products.json (FBT) + /products/<protection>.js (fee→variant map)
   Config injected by snippets/tu-cart-drawer.liquid as window.TUCartConfig.
   Cart-icon interception is bound by an early inline script (snippet) that calls window.TUCartOpen.
   ============================================================ */
(function () {
  'use strict';
  try { window.__tuScriptStart = Math.round(performance.now()); } catch (e) {} // diag: when engine began executing
  var cfg = window.TUCartConfig || {};
  var FREE_SHIP_OK = cfg.freeShipCountryOk !== false;
  var SYM = cfg.currencySymbol || '$';
  var CURR = cfg.currencyCode || 'AUD';
  var PROT_HANDLE = cfg.protectionHandle || 'shipping-protection';

  // ---- Goal config: thresholds + labels + message templates come from the shop metafield
  //      custom.tu_cart_drawer (injected as TUCartConfig.cartDrawer by the snippet). Built-in
  //      defaults below are the fallback when the metafield is missing. Edited via Mission Control. ----
  var DISC_FS = '<br><span style="color:grey;font-size:smaller;">(*Regional Delivery of Bulky Items Excluded)</span>';
  var DISC_CR = '<br><span style="color:grey;font-size:smaller;">(*Free regional delivery of bulky items excluded)</span>';
  var TIP = 'Earn Store Credit on this purchase, to redeem on your next order! (Spend targets exclude any store credit redemptions)';
  // Fallback text for the Free Shipping marker tooltip (ⓘ). The real value comes from the cart-drawer
  // config (Theme settings → "Cart drawer rewards" → Free shipping tooltip = free_ship.tooltip); this is
  // only used if that's blank/missing.
  var FS_TIP = 'Free regional delivery of bulky items excluded.';
  var DEFAULT_CD = {
    free_ship: { threshold: 99, label: 'Free Shipping*',
      locked: '🔒 Add {{amount}} to get <span style="color:#E2244D;font-weight:bold;">Free Shipping!</span>' + DISC_FS,
      unlocked: '✅ You’ve unlocked <span style="color:#53B59B;font-weight:bold;">Free Shipping!</span>' + DISC_CR },
    credit_tiers: [
      { threshold: 150, reward: '$10', label: '$10 CREDIT', tooltip: TIP,
        locked: '🔒 Add {{amount}} to unlock a <span style="color:#E2244D;font-weight:bold;">$10 Store Credit!</span>' + DISC_CR,
        unlocked: '✅ You’ve unlocked a $10 Store Credit!' },
      { threshold: 250, reward: '$20', label: '$20 CREDIT', tooltip: TIP,
        locked: '🔒 Add {{amount}} to unlock <span style="color:#E2244D;font-weight:bold;">$20 Store Credit!</span>' + DISC_CR,
        unlocked: '✅ You’ve unlocked a $20 Store Credit!' },
      { threshold: 350, reward: '$30', label: '$30 CR', tooltip: TIP,
        locked: '🔒 Add {{amount}} to unlock <span style="color:#E2244D;font-weight:bold;">$30 Store Credit!</span>' + DISC_CR,
        unlocked: '✅ You’ve unlocked a $30 Store Credit!' }
    ],
    max_message: '✅ You’ve earned the maximum store credit!' + DISC_CR
  };
  var BASE_CD = (cfg.cartDrawer && cfg.cartDrawer.free_ship) ? cfg.cartDrawer : DEFAULT_CD;
  // ---- Per-country override (NZ etc.) from cfg.cartDrawer.geo[<ISO>]. Three things it can do:
  //   (a) hide the goals entirely   → show_goals:false
  //   (b) hide specific goals       → omit free_ship (it's AU-only) / supply only some credit_tiers
  //   (c) show NZ-currency credit   → enter NZD thresholds + labels here (the NZ cart subtotal is already
  //       NZD via Shopify Markets, so NZD thresholds compare correctly).
  // The override fully replaces the goal config for that country. COUNTRY comes from Shopify localization. ----
  var GEO = (cfg.cartDrawer && cfg.cartDrawer.geo) || {};
  var COUNTRY = String(cfg.countryCode || '').toUpperCase();
  var GEO_OVR = (COUNTRY && GEO[COUNTRY]) || null;
  var HIDE_GOALS = !!(GEO_OVR && GEO_OVR.show_goals === false);
  var CD = (GEO_OVR && !HIDE_GOALS && GEO_OVR.credit_tiers) ? GEO_OVR : BASE_CD;
  var MAX_MSG = CD.max_message || DEFAULT_CD.max_message;
  function d2c(d) { return Math.round(parseFloat(d) * 100); }

  // Unified ordered goal ladder (cents): free-ship first, then credit tiers, sorted by threshold.
  var GOAL_DEFS = [];
  if (CD.free_ship) GOAL_DEFS.push({ at: d2c(CD.free_ship.threshold), label: CD.free_ship.label, locked: CD.free_ship.locked, unlocked: CD.free_ship.unlocked, tooltip: CD.free_ship.tooltip, fs: true });
  (CD.credit_tiers || []).forEach(function (t) { GOAL_DEFS.push({ at: d2c(t.threshold), label: t.label, locked: t.locked, unlocked: t.unlocked, tooltip: t.tooltip, fs: false }); });
  GOAL_DEFS.sort(function (a, b) { return a.at - b.at; });

  var FREE_SHIP = CD.free_ship ? d2c(CD.free_ship.threshold) : 9900;
  // Evenly-spaced marker/fill positions across however many goals exist (last at 95%).
  var MARK_POS = GOAL_DEFS.map(function (g, i) { return Math.round(((i + 1) / GOAL_DEFS.length) * 95); });
  // Nudge the first marker (the wide "Free Shipping*" label) left so it clears the next label.
  if (MARK_POS.length >= 2) MARK_POS[0] = Math.max(10, MARK_POS[0] - 8);
  // [cents, bar-position %] anchors for the piecewise progress fill.
  var FILL_PTS = [[0, 0]].concat(GOAL_DEFS.map(function (g, i) { return [g.at, MARK_POS[i]]; }));

  var root, panel, itemsEl, noteEl, subtotalEl, fsMsgEl, barFill, markers, markersWrap, creditMsgEl, rewardsEl, closeBtn, fbtEl, fbtBody;
  var checkoutBtn, protCheck, protPriceEl, protRow, toastEl;
  var cart = null, isOpen = false, lastFocus = null, lastFbtSig = null;
  var protMap = null, protLoaded = false, qtyTimers = {}, toastTimer, pendingAdd = false;
  var inventoryCache = {}, inventoryPending = {};
  var activeWatchStop = null; // set while a Kaching add is being watched; lets a user cart-edit cancel it
  var checkingOut = false;    // once checkout starts, keep the "Loading checkout…" overlay until we navigate
  var cartEditSeq = 0;        // bumped on any user cart edit; lets an in-flight add abandon its late reconcile

  function money(c) { var p = (c / 100).toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return SYM + p.join('.'); }
  function parseMoney(s) { var n = (s || '').replace(/[^0-9.]/g, ''); return n ? Math.round(parseFloat(n) * 100) : 0; }
  // Kaching bundle pricing isn't in the cart fast — Shopify's cart-transform takes ~14s to settle the
  // line price, and the combined compare-at (RRP) is never in the cart at all. But Kaching KNOWS both
  // on the product-page deal bar: `.kaching-bundles__bar-price` ($608 deal) and `.bar-full-price`
  // ($1,308 RRP), matched to the line by bar id. We read those and display them INSTANTLY (like
  // Kaching's own drawer), caching by bar id in localStorage so they persist when the cart reopens
  // elsewhere. The slow cart total still settles correctly server-side for checkout.
  function kbPrices(line) {
    var raw = line.properties && line.properties.__kaching_bundles;
    if (!raw) return null;
    var barId; try { barId = JSON.parse(raw).bar; } catch (e) { return null; }
    if (!barId) return null;
    var compare = 0, deal = 0, count = 0;
    try {
      var bar = document.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + barId + '"]');
      if (bar) {
        var fEl = bar.querySelector('.kaching-bundles__bar-full-price');
        var dEl = bar.querySelector('.kaching-bundles__bar-price');
        if (fEl) compare = parseMoney(fEl.textContent);
        if (dEl) deal = parseMoney(dEl.textContent);
        // The bar prices are the TOTAL for the whole bundle (e.g. $246 / $498 for a 2-bag set), but each
        // bundle component is its own cart line. Read how many items the bundle covers (leading number in the
        // bar title, e.g. "2 Suitcase or Bag Set") so callers can show the PER-ITEM price on each line instead
        // of the bundle total on every line (which made a 2-set read $246 ×2 = $492). Single-item deals have
        // no leading number → count 1 (unchanged).
        var tEl = bar.querySelector('.kaching-bundles__bar-title');
        var tm = tEl && (tEl.textContent || '').match(/^\s*(\d+)\b/);
        if (tm) count = +tm[1] || 0;
        if (compare || deal) { try { localStorage.setItem('tu_kb_' + barId, compare + ':' + deal + ':' + count); } catch (e) {} }
      }
    } catch (e) {}
    if (!compare && !deal) { try { var s = (localStorage.getItem('tu_kb_' + barId) || '').split(':'); compare = +s[0] || 0; deal = +s[1] || 0; count = +s[2] || 0; } catch (e) {} }
    return (compare || deal) ? { compare: compare, deal: deal, count: count || 1 } : null;
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // Expected total item_count for a Kaching bundle add: identify the bundle from a landed line's bar id
  // (`__kaching_bundles.bid`), find that deal bar on the page, and read the count that leads its title
  // ("3 Suitcase or Bag Set" → 3). Lets watchAdd settle the instant every line has LANDED (~11s) rather
  // than waiting for Kaching's slow /cart/add RESPONSES (~24s). Returns 0 when it can't be determined.
  // Number of items in the deal the shopper currently has selected, read at add-time. Decides whether to
  // show the "Loading bundle…" overlay — the single-item default deal isn't a bundle, so it gets none.
  // Primary signal is the Kaching FORM's __kaching_bundles.bid (stable at submit, unlike the bars' transient
  // --selected class): bid → the matching deal bar → its `.kaching-bundles__collection-product` count
  // (1 for the single, 3 for the 3-set). Title number ("3 Suitcase…") and --selected are fallbacks.
  function barSize(bar) {
    if (!bar) return 0;
    var slots = bar.querySelectorAll('.kaching-bundles__collection-product').length;
    var t = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
    var m = t.match(/^\s*(\d+)\b/);
    return Math.max(slots, m ? parseInt(m[1], 10) : 0);
  }
  function selectedBundleSize() {
    try {
      var bid = null;
      var kp = document.querySelector('[name="properties[__kaching_bundles]"]');
      if (kp && kp.value) { try { var pj = JSON.parse(kp.value); bid = pj.bid || pj.bar; } catch (e) {} }
      var bar = bid ? document.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + bid + '"]') : null;
      if (!bar) bar = document.querySelector('.kaching-bundles__bar--selected');
      return Math.max(1, barSize(bar));
    } catch (e) { return 1; }
  }
  function bundleTargetCount(c, baseline) {
    if (!c || !c.items) return 0;
    for (var k = 0; k < c.items.length; k++) {
      var raw = c.items[k].properties && c.items[k].properties.__kaching_bundles;
      if (!raw) continue;
      var bid; try { var pj = JSON.parse(raw); bid = pj.bid || pj.bar; } catch (e) { continue; }
      if (!bid) continue;
      try {
        var bar = document.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + bid + '"]');
        var title = (bar && bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
        var m = title.match(/^\s*(\d+)\b/);
        if (m) { var n = parseInt(m[1], 10); if (n >= 1 && n <= 12) return baseline + n; }
      } catch (e) {}
    }
    return 0;
  }

  function init() {
    root = document.getElementById('tu-cart');
    if (!root) return;
    root.inert = true;   // closed at boot: keep descendants out of tab order + a11y tree (a11y: aria-hidden-focus)
    panel = root.querySelector('.tu-cart__panel');
    itemsEl = root.querySelector('.tu-cart__items');
    noteEl = root.querySelector('.tu-cart__note');
    subtotalEl = root.querySelector('.tu-cart__subtotal-val');
    fsMsgEl = root.querySelector('.tu-cart__freeship-msg');
    barFill = root.querySelector('.tu-cart__bar-fill');
    // Build progress markers from the resolved goal config (labels + thresholds come from the metafield).
    markersWrap = root.querySelector('.tu-cart__markers');
    if (markersWrap) {
      markersWrap.innerHTML = GOAL_DEFS.map(function (g, i) {
        // The free-ship goal carries a tooltip (ⓘ) on its marker — text from the cart-drawer config
        // (Theme settings → free_ship.tooltip), falling back to the built-in default.
        return '<span class="tu-cart__marker' + (g.fs ? ' tu-cart__marker--fs' : '') + '" data-tu-at="' + g.at + '" style="left:' + MARK_POS[i] + '%">' + esc(g.label) + (g.fs ? infoHTML(g.tooltip || FS_TIP) : '') + '</span>';
      }).join('');
    }
    markers = [].slice.call(root.querySelectorAll('.tu-cart__marker'));
    bindTooltips();
    creditMsgEl = root.querySelector('.tu-cart__credit-msg');
    rewardsEl = root.querySelector('.tu-cart__rewards');
    // Country override says hide goals (e.g. NZ option a) → remove the rewards bar + credit message entirely.
    if (HIDE_GOALS) {
      if (rewardsEl) rewardsEl.style.display = 'none';
      if (creditMsgEl) creditMsgEl.style.display = 'none';
    }
    closeBtn = root.querySelector('.tu-cart__close');
    toastEl = root.querySelector('.tu-cart__toast');
    fbtEl = root.querySelector('.tu-cart__fbt');
    fbtBody = root.querySelector('.tu-cart__fbt-body');
    checkoutBtn = root.querySelector('.tu-cart__checkout');
    protCheck = root.querySelector('.tu-cart__protect-check');
    protPriceEl = root.querySelector('.tu-cart__protect-price');
    protRow = root.querySelector('.tu-cart__protect');

    root.querySelector('.tu-cart__overlay').addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

    itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tu-act]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var row = btn.closest('[data-tu-key]');
      var key = row && row.getAttribute('data-tu-key');
      var line = cart && cart.items.filter(function (i) { return i.key === key; })[0];
      if (!line) return;
      var act = btn.getAttribute('data-tu-act');
      if (act === 'inc') {
        var max = lineMax(line);
        if (max != null && line.quantity >= max) return; // at stock cap — no flash, no-op
      }
      queueQty(key, act === 'inc' ? line.quantity + 1 : act === 'dec' ? Math.max(0, line.quantity - 1) : 0, row);
    });

    if (noteEl) {
      var t;
      noteEl.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: noteEl.value }) }); }, 600);
      });
    }

    if (fbtBody) {
      fbtBody.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tu-add]');
        if (!b) return;
        e.preventDefault();
        addVariant(+b.getAttribute('data-tu-add'));
      });
    }

    if (checkoutBtn) checkoutBtn.addEventListener('click', function (e) { e.preventDefault(); goCheckout(protCheck ? protCheck.checked : false); });

    var continueBtn = root.querySelector('.tu-cart__continue');
    if (continueBtn) continueBtn.addEventListener('click', function (e) { e.preventDefault(); close(); });

    window.TUCartOpen = open; // used by the early inline interceptor in the snippet
    window.TUCartAdd = function (formData, form) { open(true); return addToCart(formData, true, form); }; // instant drawer + optimistic add
    window.TUCartWatchAdd = watchAdd; // Kaching/3rd-party add → detect cart change, then open our drawer
    if (window.__tuWatchAdd) { window.__tuWatchAdd = false; watchAdd(); }
    loadProtMap().then(function () { if (cart) render(); });
    try { window.__tuEngineReadyAt = Math.round(performance.now()); } catch (e) {} // diag: engine wired up
    fetchCart().then(function () {
      render();
      // If the shell was opened early (cart icon clicked before this deferred engine loaded), finish the open
      // and clear the "Loading cart…" overlay the snippet put up.
      if (window.__tuPendingOpen) { window.__tuPendingOpen = false; open(true); hideLoader(); }
    });
  }

  function fetchCart() {
    // First call reuses the parse-time prefetch (warmed by the snippet) so the cart renders instantly on
    // boot with no extra round-trip — critical on the homepage where the engine loads late. One-shot.
    var pre = window.__tuCartPrefetch;
    if (pre) {
      window.__tuCartPrefetch = null;
      return pre.then(function (c) { cart = c; return c; })
        .catch(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
        });
    }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  // Optimistic qty: update local cart + DOM immediately, debounce the network commit.
  // (Fixes rapid +/- clicks that previously read a stale quantity mid-request.)
  function queueQty(key, qty, row) {
    var line = cart.items.filter(function (i) { return i.key === key; })[0];
    if (!line) return;
    // A user cart-edit makes any in-progress add obsolete — cancel the Kaching watcher AND invalidate any
    // in-flight optimistic addToCart, so their late reconcile can't overwrite this edit with the pre-edit cart
    // (which left the nav badge showing the old count after removing the last item).
    if (activeWatchStop) { activeWatchStop(); activeWatchStop = null; }
    cartEditSeq++;
    line.quantity = qty;
    if (qty <= 0) {
      cart.items = cart.items.filter(function (i) { return i.key !== key; });
      cart.item_count = cart.items.reduce(function (s, i) { return s + i.quantity; }, 0); // keep count in sync
      render();
    } else {
      var v = row.querySelector('.tu-cart__qty-val');
      if (v) v.textContent = qty;
      recomputeFromLocal();
    }
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () { commitQty(key, qty); }, 350);
  }
  function commitQty(key, qty) {
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (res.ok && res.body && res.body.items) {
          cart = res.body;
          // Success: Shopify may still have clamped the line to available stock.
          var returned = cart.items.filter(function (i) { return i.key === key; })[0];
          if (returned && qty > returned.quantity) capToast(returned, returned.quantity);
          render();
        } else {
          // Inventory cap → /cart/change.js returns HTTP 422 (an error JSON, not a cart). Re-sync from
          // the server; the line's real quantity is the max available, then explain with a toast.
          fetchCart().then(function (c) {
            var line = c.items.filter(function (i) { return i.key === key; })[0];
            var avail = line ? line.quantity : 0;
            if (qty > avail) capToast(line, avail);
            render();
          });
        }
      })
      .catch(function () { fetchCart().then(render); });
  }
  // Toast the available cap + mark the variant unavailable so the + button disables and "Only N left" shows.
  function capToast(line, n) {
    showToast('Only ' + n + ' unit' + (n === 1 ? '' : 's') + ' available');
    if (line) {
      inventoryCache[line.product_id] = inventoryCache[line.product_id] || {};
      inventoryCache[line.product_id][line.variant_id] = { available: false };
    }
  }
  function recomputeFromLocal() {
    var sub = productSubtotal();
    if (subtotalEl) subtotalEl.textContent = money(sub);
    renderRewards(sub);
    renderProtection(sub);
    updateCount(cart.items.reduce(function (s, i) { return s + i.quantity; }, 0));
  }

  function addVariant(id) { addToCart({ id: id, quantity: 1 }, false); }

  // For adds we DON'T perform ourselves (Kaching Bundles builds the full multi-item bundle via its own
  // handler). We let that run, then poll /cart.js until item_count rises and open our drawer with the
  // complete cart. App-agnostic (no dependency on Kaching's fetch/XHR wrapper). Baseline is the current
  // in-memory count captured synchronously so a slow add can't be missed.
  var watching = false;
  // Full-panel overlay shown during any add/update. Text varies: "Loading bundle…" for a multi-item Kaching
  // bundle, "Updating…" for a single item or a plain product add — so the shopper always gets feedback during
  // the (server-bound) load, without a single item being mislabelled as a bundle.
  function showLoader(text) {
    if (!root) return;
    var t = root.querySelector('.tu-cart__loader-text');
    if (t && text) t.textContent = text;
    root.classList.add('tu-cart--loading');
  }
  function hideLoader() { if (root && !checkingOut) root.classList.remove('tu-cart--loading'); }
  // Kaching adds a mix-and-match bundle as SEVERAL sequential, server-side /cart/add calls — the main
  // item via the product form, then each chosen item via Kaching's own JS — and every one runs Shopify's
  // cart-transform, which is slow (a 3-item bundle was measured at ~8s for the first line and ~30s for
  // the last). Shopify also serialises cart access, so the OLD approach here (poll /cart.js every 300ms)
  // piled dozens of requests behind Kaching's cart lock and actually slowed its adds (each /cart.js then
  // took ~20s); it also (a) gave up at 7.2s — before the first line had even landed — and (b) stopped at
  // the FIRST count change, so multi-add bundles only ever showed 1 of N items.
  //
  // New approach: open instantly, then poll GENTLY and NON-OVERLAPPING so we never contend with Kaching's
  // adds, render each line as it lands (the bundle streams in), and keep going until EVERY Kaching add has
  // finished. We know that via window.__tuAddsInFlight (a passive counter the snippet keeps by watching
  // fetch) — settled = count rose AND no add is in flight AND the cart has held steady briefly. A 60s hard
  // cap guards against a hang. Line PRICES come from each line's settled final_price; checkout is authoritative.
  function watchAdd() {
    if (watching) return;
    watching = true;
    pendingAdd = true;
    captureBundleKidsFromWidget();   // grab the chosen children NOW, before Kaching adds/merges them away
    // Always overlay during the load; a multi-item bundle says "Loading bundle…", a single deal "Updating…".
    showLoader(selectedBundleSize() >= 2 ? 'Loading bundle…' : 'Updating…');
    open(true);            // drawer slides in instantly with the current cart
    if (cart) render();    // shows existing lines + an "Adding to cart…" placeholder when empty
    var baseline = cart ? cart.item_count : 0;
    var lastCount = baseline, lastLines = cart ? cart.items.length : 0;
    var stable = 0, started = Date.now(), inFlight = false, lastPoll = 0, iv, stopped = false, sawAdds = false;
    window.__tuLastAddItems = null;   // ignore any stale capture; only react to THIS add's response
    // Render the new line straight from Kaching's /cart/add response (captured by the snippet) as soon as it
    // lands, instead of waiting for the next /cart.js to confirm it — saves the round-trip (~0.5s). The poll
    // below still reconciles to the authoritative cart right after.
    function mergeAddItems() {
      var ni = window.__tuLastAddItems;
      if (!ni || !ni.length) return;
      window.__tuLastAddItems = null;   // ONE-SHOT: consume it, so a line the shopper then removes can't
                                        // be re-added by a later tick (that caused the nav badge to revive).
      if (!cart) cart = { items: [], item_count: 0 };
      var added = false;
      ni.forEach(function (it) {
        if (!it || !it.key) return;
        var ex = cart.items.filter(function (i) { return i.key === it.key; })[0];
        if (!ex) { cart.items.push(it); added = true; }
        else if (it.quantity && it.quantity !== ex.quantity) { ex.quantity = it.quantity; added = true; }
      });
      if (added) { cart.item_count = cart.items.reduce(function (s, i) { return s + i.quantity; }, 0); render(); }
    }
    function finish(c) {
      clearInterval(iv); stopped = true; watching = false; pendingAdd = false; activeWatchStop = null;
      window.__tuLastAddItems = null;  // done watching — drop any captured add so it can't re-merge later
      hideLoader();                    // bundle complete → drop the overlay (unless we're mid-checkout)
      if (c) cart = c;
      if (cart) render();
    }
    // Lets a user cart-edit (remove/qty change) abort this watcher WITHOUT a final render, so a late poll
    // or settle can't overwrite the edit with the pre-edit cart (that revived the nav badge after removal).
    activeWatchStop = function () {
      clearInterval(iv); stopped = true; watching = false; pendingAdd = false; activeWatchStop = null;
      window.__tuLastAddItems = null;
      hideLoader();
    };
    // A fine 200ms heartbeat, but the actual /cart.js read is THROTTLED by addsInFlight: while a Kaching
    // /cart/add holds Shopify's cart-write lock, extra reads only queue behind it and SLOW the add (a read
    // issued mid-add was measured at ~2.9s), so we poll at most ~every 1.2s then; the instant the add clears
    // we poll briskly (~250ms) to surface the result without the old ~1s polling lag.
    iv = setInterval(function () {
      if (stopped) return;
      mergeAddItems();                            // surface the new line the instant the add responds
      if (inFlight) return;                       // never overlap — a queued /cart.js piles on the lock
      var now = Date.now();
      var addsBusy = (window.__tuAddsInFlight || 0) > 0;
      if (addsBusy) sawAdds = true;   // remember a Kaching /cart/add fired, so we can detect a no-op failure
      var minGap = addsBusy ? 1200 : 250;
      if (now - lastPoll < minGap) return;
      lastPoll = now;
      inFlight = true;
      var elapsed = now - started;
      // A /cart.js can get queued behind Kaching's cart-write lock and hang for ~20s. Abort it after 2.5s
      // so a single stuck read can't freeze the watcher (the old binary in-flight guard would never clear,
      // leaving the "Loading bundle…" overlay stuck even after the cart had settled). We just retry next tick.
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var to = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 2500) : 0;
      fetch('/cart.js', { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (to) clearTimeout(to);
          inFlight = false;
          if (stopped) return;                      // cancelled mid-flight (user edited the cart) — discard
          var changed = c.item_count !== lastCount || c.items.length !== lastLines;
          if (changed) { lastCount = c.item_count; lastLines = c.items.length; stable = 0; cart = c; render(); }
          else if (c.item_count > baseline) { stable++; }
          var addsBusy = (window.__tuAddsInFlight || 0) > 0;
          if (addsBusy) sawAdds = true;
          var sinceAdd = Date.now() - (window.__tuLastAddDone || 0);
          // FAILURE / no-op: the add made no progress. Kaching aborts a bundle when a component is out of
          // stock (e.g. a 1-stock item whose only unit is already in the cart from another bundle) — it shows
          // its own "…is already sold out" notice and either never fires /cart/add or fires ones that 422.
          // Either way item_count never leaves baseline, which USED to keep "Loading bundle…" up for the full
          // 60s cap. Bail as soon as we're confident nothing will land: adds fired but added nothing and have
          // settled (the common case), OR no add ever fired and Kaching's slow first-add window (~8s) has passed.
          var noProgress = c.item_count <= baseline && !addsBusy;
          if (noProgress && ((sawAdds && sinceAdd > 3000) || (!sawAdds && elapsed > 12000))) {
            showToast("Couldn't add — an item in this bundle is out of stock.");
            finish(c); return;
          }
          // FAST path: every line of the bundle has landed (count reached the bar's advertised size). This
          // fires ~when the cart is visually complete, not when Kaching's slow /cart/add responses return.
          var target = bundleTargetCount(c, baseline);
          var reached = target > 0 && c.item_count >= target;
          // Safety net: if the cart confirms this is a multi-item bundle but the start-time size read missed
          // it (the deal widget can be mid-render at submit), upgrade the overlay to "Loading bundle…" now.
          // Never fires for a single item (its target is baseline+1).
          if (target > baseline + 1) showLoader('Loading bundle…');
          // SLOW/fallback path (target unknown — e.g. a single-item deal): wait until no Kaching add is
          // still in flight and the cart has held steady. Riding the tracker rides out the gaps between a
          // bundle's sequential adds rather than stopping after the first line.
          var heldSteady = c.item_count > baseline && !addsBusy && sinceAdd > 1500 && stable >= 2;
          if (reached || heldSteady || elapsed > 60000) finish(c);
        })
        .catch(function () {
          if (to) clearTimeout(to);
          inFlight = false;                       // aborted/failed read → just try again next tick
          if (stopped) return;
          if (Date.now() - started > 60000) finish(null);
        });
    }, 200);
  }

  // Build a placeholder cart line from the page (product card or PDP) so we can show the item INSTANTLY on
  // click — the server /cart/add is slow here (~3.5s: Kaching/Redeemly cart-transform), and Monster's cart
  // wins purely by rendering optimistically rather than waiting. The real line (with its key) replaces this
  // when /cart/add.js returns. Returns null if we can't read enough to draw it (then we fall back to a spinner).
  function optimisticLineFromForm(form) {
    try {
      var idEl = form && form.querySelector('[name="id"]');
      var vid = idEl ? +idEl.value : 0;
      if (!vid) return null;
      var card = (form.closest && form.closest('.card-wrapper, .grid__item, li.card, .card')) || document;
      var titleEl = card.querySelector('.card__heading, .card__heading a') || document.querySelector('.product__title') || document.querySelector('h1');
      var imgEl = card.querySelector('img') || document.querySelector('.product__media img, .product-media img, [class*="product"] img');
      var priceEl = card.querySelector('.price__sale .price-item--sale, .price-item--sale, .price-item--regular, [class*="price-item"]')
                 || document.querySelector('.price__sale .price-item--sale, .price-item--sale, .price-item--regular, [class*="price-item"]');
      var img = imgEl ? (imgEl.currentSrc || imgEl.getAttribute('src') || '') : '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      var linkEl = card.querySelector && card.querySelector('a[href*="/products/"]');
      var cents = parseMoney(priceEl ? priceEl.textContent : '');
      return {
        key: 'tu-pending-' + vid, id: vid, variant_id: vid, quantity: 1,
        product_title: titleEl ? titleEl.textContent.trim() : 'Adding item…',
        variant_title: '', product_type: '', properties: {}, discounts: [],
        image: img, url: linkEl ? linkEl.getAttribute('href') : '#',
        price: cents, final_price: cents, __pending: true
      };
    } catch (e) { return null; }
  }

  // Optimistic add: draw the item NOW from the page (no wait), fire /cart/add.js, then swap the placeholder
  // for the real line and reconcile/stock-check in the background. (Server add is the slow part — we don't
  // block the render on it.)
  function addToCart(payload, asForm, form) {
    pendingAdd = true;
    var seq = cartEditSeq;                       // if the user edits the cart before our async finishes, bail
    var stale = function () { return cartEditSeq !== seq; };
    var opt = form ? optimisticLineFromForm(form) : null;
    var alreadyIn = opt && cart && cart.items.some(function (i) { return i.variant_id === opt.variant_id && !i.__pending; });
    if (opt && cart && !alreadyIn) {
      cart.items.push(opt);                                   // NEW line → show instantly, no overlay
      cart.item_count = cart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
      render();
    } else {
      showLoader('Updating…');                                // re-add / no card data → spinner until confirmed
      if (cart) render();
    }
    var opts = asForm
      ? { method: 'POST', body: payload, headers: { Accept: 'application/json' } }
      : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) };
    return fetch('/cart/add.js', opts)
      .then(function (r) { return r.json(); })
      .then(function (added) {
        if (stale()) return;                    // user edited the cart since this add began → abandon
        var line = (added && added.id) ? added : (added && added.items ? added.items[0] : null);
        var newItems = added && added.items ? added.items : (added && added.id ? [added] : []);
        var willVerify = !!(line && line.key && line.quantity > 1);
        if (cart) {
          cart.items = cart.items.filter(function (i) { return !i.__pending; });  // drop the placeholder
          newItems.forEach(function (ni) {
            var ex = cart.items.filter(function (i) { return i.key === ni.key; })[0];
            if (ex) ex.quantity = ni.quantity || (ex.quantity + 1); else cart.items.push(ni);
          });
          cart.item_count = cart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
          // Show the real line now — UNLESS a stock-cap check is pending (qty>1): then keep the overlay so the
          // possibly-oversold quantity never flashes; the final render below reveals the capped result + toast.
          if (!willVerify) { hideLoader(); render(); }
        }
        // STOCK CAP (background): /cart/add.js can OVERSELL where /cart/change.js ENFORCES. If a line is now
        // >1, re-assert that quantity via change.js — it caps to available + 422s if exceeded → toast.
        if (willVerify) {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity }) })
            .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b, key: line.key }; }); })
            .then(function (res) {
              if (stale()) return;
              if (res.ok && res.body && res.body.items) { cart = res.body; return; }
              return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
                if (stale()) return;
                cart = c;
                var l = c.items.filter(function (i) { return i.key === res.key; })[0];
                capToast(l, l ? l.quantity : 0);
              });
            });
        }
        // background reconcile (totals/keys) — guarded so a removal mid-flight isn't clobbered
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { if (!stale()) cart = c; });
      })
      .then(function () { pendingAdd = false; if (stale()) return; hideLoader(); render(); })
      .catch(function () { pendingAdd = false; if (stale()) return; hideLoader(); fetchCart().then(render); });
  }

  function open(skipFetch) {
    var wasOpen = isOpen;
    if (!wasOpen) {
      isOpen = true; lastFocus = document.activeElement;
      root.classList.add('tu-cart--open');     // drawer slides in instantly — no network wait
      root.setAttribute('aria-hidden', 'false');
      root.inert = false;                      // open: descendants focusable again
      document.documentElement.classList.add('tu-cart-lock');
      setKlaviyo(false);
      if (closeBtn) closeBtn.focus();
    }
    if (skipFetch) { if (cart) render(); }      // add flow renders the current cart now, reconciles itself
    else fetchCart().then(render);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('tu-cart--open');
    root.setAttribute('aria-hidden', 'true');
    root.inert = true;                         // closed: remove descendants from tab order + a11y tree
    document.documentElement.classList.remove('tu-cart-lock');
    setKlaviyo(true);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function setKlaviyo(visible) {
    ['[id^="klaviyo-"]', '[id^="klaviyo_"]', '[id^="kl-"]', 'iframe[src*="klaviyo"]'].forEach(function (sel) {
      try { document.querySelectorAll(sel).forEach(function (el) {
        el.style.setProperty('display', visible ? '' : 'none', 'important');
      }); } catch (e) {}
    });
  }
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('tu-cart__toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('tu-cart__toast--show'); }, 3200);
  }

  // Info-icon tooltips next to the goal message text (hover/focus desktop, tap-toggle mobile).
  // Delegated on `root` (bound once) so icons inside re-rendered messages keep working.
  var tipEl = null;
  function showTip(icon) {
    var tip = icon.getAttribute('data-tip'); if (!tip || !tipEl) return;
    tipEl.innerHTML = tip;   // tooltips support basic HTML (<br>, <strong>, …) — content is merchant-controlled (theme settings), not user input
    tipEl.__tip = tip;        // track the raw value so the tap-to-toggle check below still works with HTML content
    tipEl.classList.add('tu-cart__tip--show');
    var ir = icon.getBoundingClientRect(), tw = tipEl.offsetWidth || 220, th = tipEl.offsetHeight;
    var left = ir.left + ir.width / 2 - tw / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - tw - 8)); // clamp to viewport
    var top = ir.bottom + 8;
    if (top + th > window.innerHeight - 8) top = ir.top - th - 8; // flip above if no room below
    tipEl.style.left = left + 'px';
    tipEl.style.top = Math.max(8, top) + 'px';
  }
  function hideTip() { if (tipEl) tipEl.classList.remove('tu-cart__tip--show'); }
  function infoHTML(tip) { return tip ? ' <span class="tu-cart__info" tabindex="0" role="button" aria-label="More info" data-tip="' + esc(tip) + '">i</span>' : ''; }
  function bindTooltips() {
    if (tipEl) return; // bind once
    tipEl = document.createElement('div'); tipEl.className = 'tu-cart__tip'; tipEl.setAttribute('role', 'tooltip'); root.appendChild(tipEl);
    root.addEventListener('mouseover', function (e) { var i = e.target.closest('.tu-cart__info'); if (i) showTip(i); });
    root.addEventListener('mouseout', function (e) { if (e.target.closest('.tu-cart__info')) hideTip(); });
    root.addEventListener('focusin', function (e) { var i = e.target.closest('.tu-cart__info'); if (i) showTip(i); });
    root.addEventListener('focusout', function (e) { if (e.target.closest('.tu-cart__info')) hideTip(); });
    root.addEventListener('click', function (e) {
      var i = e.target.closest('.tu-cart__info'); if (!i) return;
      e.preventDefault(); e.stopPropagation();
      var shown = tipEl.classList.contains('tu-cart__tip--show') && tipEl.__tip === i.getAttribute('data-tip');
      if (shown) hideTip(); else showTip(i);
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.tu-cart__info')) hideTip(); });
  }

  function productSubtotal() {
    if (!cart) return 0;
    // final_price × quantity (not final_line_price) so optimistic qty changes recompute instantly.
    // Kaching bundle lines carry their own settled per-component discounted price in final_price too.
    return cart.items.reduce(function (s, i) {
      if (/ship_protect/i.test(i.product_type || '')) return s;
      // Sum each line's own settled price (Kaching writes per-component discounted prices into the cart lines).
      return s + i.final_price * i.quantity;
    }, 0);
  }

  // Shopify's product.js no longer exposes inventory_quantity/policy. We use v.available
  // to detect "at cart cap" — when a variant the user already has becomes unavailable,
  // they have the full stock. lineMax then returns the current cart qty so the + button
  // disables and we show "Only X left" (= the in-stock count for that variant).
  function lineMax(item) {
    var inv = inventoryCache[item.product_id];
    if (!inv) return null;
    var info = inv[item.variant_id];
    if (!info) return null;
    return info.available ? null : item.quantity;
  }
  // Variant compare-at (RRP) in cents, from the same product.js we fetch for inventory. The cart line's
  // own compare_at_price is null on Kaching mix-and-match component lines, so we read it per-variant here.
  function variantCompare(item) {
    var inv = inventoryCache[item.product_id];
    var info = inv && inv[item.variant_id];
    if (info && info.compare) return info.compare;
    // Fall back to the Liquid-seeded RRP map (items present at page load) so the line-item strikethrough
    // paints instantly, before /products/<handle>.js has populated inventoryCache.
    var seed = window.__tuVariantCompare && window.__tuVariantCompare[item.variant_id];
    return seed || 0;
  }
  // Preorder = inventory tracked + policy "continue" + qty <= 0. inventory_quantity/policy are NOT in
  // /products/<handle>.js, so we read them from a server-rendered probe section (sections/tu-preorder.liquid)
  // via the Section Rendering API, cached per product alongside the inventory map.
  // How many cart lines belong to the same Kaching bundle instance as this line (grouped by deal-bar id).
  // 1 = the whole bundle is a single combined line; >1 = separate component lines.
  function bundleLineCount(item) {
    if (!cart || !item.properties || !item.properties.__kaching_bundles) return 1;
    var key; try { key = JSON.parse(item.properties.__kaching_bundles).bar; } catch (e) { return 1; }
    if (!key) return 1;
    var n = 0;
    cart.items.forEach(function (it) {
      var raw = it.properties && it.properties.__kaching_bundles;
      if (!raw) return;
      try { if (JSON.parse(raw).bar === key) n++; } catch (e) {}
    });
    return n || 1;
  }
  function isPreorder(item) {
    // Items already in the cart at page load: flagged server-side into window.__tuPreorderVids (instant).
    if (window.__tuPreorderVids && window.__tuPreorderVids.indexOf(item.variant_id) >= 0) return true;
    // Items added during the session: from the per-product probe fetched in ensureInventoryFor.
    var inv = inventoryCache[item.product_id];
    var info = inv && inv[item.variant_id];
    return !!(info && info.preorder);
  }
  function ensureInventoryFor(items) {
    var fetches = [];
    items.forEach(function (i) {
      if (/ship_protect/i.test(i.product_type || '')) return;
      if (i.product_id in inventoryCache || inventoryPending[i.product_id] || !i.handle) return;
      inventoryPending[i.product_id] = true;
      var pjP = fetch('/products/' + i.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      var poP = fetch('/products/' + i.handle + '?section_id=tu-preorder').then(function (r) { return r.text(); })
        .then(function (h) { var m = h.match(/data-tu-preorder[^>]*>([^<]*)</); try { return (JSON.parse(m[1]).preorder) || []; } catch (e) { return []; } })
        .catch(function () { return []; });
      fetches.push(Promise.all([pjP, poP])
        .then(function (res) {
          var p = res[0], pre = res[1] || [];
          var map = {};
          (p.variants || []).forEach(function (v) { map[v.id] = { available: !!v.available, compare: v.compare_at_price ? +v.compare_at_price : 0, preorder: pre.indexOf(v.id) >= 0 }; });
          inventoryCache[i.product_id] = map;
        })
        .catch(function () { inventoryCache[i.product_id] = {}; }));
    });
    if (fetches.length) Promise.all(fetches).then(function () { render(); });
  }

  // Kaching merges a mix-and-match bundle's component lines into ONE parent line ("2 Suitcase or Bag Set")
  // whose only data is __kaching_bundles{mixAndMatchMerged, bar} — the children aren't in /cart.js, in a
  // Liquid-readable metafield, or on the product. But BEFORE the merge the components are ordinary cart lines
  // that share the parent's `bar`; capture their titles (keyed by bar) whenever we see them so the merged line
  // can list them. These are the same children Shopify expands on the checkout page.
  function captureBundleKids(c) {
    if (!c || !c.items) return;
    var byBar = {};
    c.items.forEach(function (it) {
      var kb; try { kb = JSON.parse(it.properties.__kaching_bundles); } catch (e) { return; }
      if (!kb || !kb.bar || kb.mixAndMatchMerged) return;     // skip the merged parent itself
      if (!(kb.main || kb.bundleProduct)) return;             // only genuine mix-and-match component lines
      (byBar[kb.bar] = byBar[kb.bar] || []).push(it.product_title);
    });
    Object.keys(byBar).forEach(function (bar) {
      // Grow-only: during the add the bundle's components land one /cart/add at a time, so an early render may
      // see only 1 of N. Don't let a partial set clobber a fuller one; an equal-size set DOES replace (handles
      // "Change Item?" swapping a component for another at the same count).
      var next = byBar[bar], prev = [];
      try { prev = JSON.parse(localStorage.getItem('tuBk_' + bar) || '[]') || []; } catch (e) {}
      if (next.length >= prev.length) { try { localStorage.setItem('tuBk_' + bar, JSON.stringify(next)); } catch (e) {} }
    });
  }
  // Capture the SELECTED bundle's child titles straight from the deal widget at add-time. This is the reliable
  // source: Kaching sometimes adds the bundle as the pre-merged product directly, so the component lines never
  // appear in /cart.js for captureBundleKids() to see. The widget always shows the chosen items at the moment
  // of "Add to cart". Keyed by the deal-bar id (== the merged line's __kaching_bundles.bar).
  function captureBundleKidsFromWidget() {
    try {
      var bars = document.querySelectorAll('.kaching-bundles__bar');
      for (var b = 0; b < bars.length; b++) {
        var bar = bars[b];
        var radio = bar.querySelector('input[type=radio]');
        var selected = radio ? radio.checked : /selected|active/.test(bar.className || '');
        if (!selected) continue;
        var barId = bar.getAttribute('data-deal-bar-id');
        if (!barId) continue;
        var comps = bar.querySelectorAll('.kaching-bundles__mix-and-match-product, .kaching-bundles__collection-product');
        var titles = [];
        for (var ci = 0; ci < comps.length; ci++) {
          var tEl = comps[ci].querySelector('.kaching-bundles__mix-and-match-product__title-link, .kaching-bundles__mix-and-match-product__title, .kaching-bundles__collection-product__title');
          var s = tEl ? (tEl.textContent || '').trim() : '';
          if (s) titles.push(s);
        }
        var prev = []; try { prev = JSON.parse(localStorage.getItem('tuBk_' + barId) || '[]') || []; } catch (e) {}
        if (titles.length >= prev.length && titles.length) { try { localStorage.setItem('tuBk_' + barId, JSON.stringify(titles)); } catch (e) {} }
      }
    } catch (e) {}
  }
  function mergedBundleKids(i) {
    if (!(i.properties && i.properties.__kaching_bundles)) return [];
    var kb; try { kb = JSON.parse(i.properties.__kaching_bundles); } catch (e) { return []; }
    if (!kb || !kb.mixAndMatchMerged || !kb.bar) return [];
    try { return JSON.parse(localStorage.getItem('tuBk_' + kb.bar) || '[]') || []; } catch (e) { return []; }
  }
  function render() {
    if (!cart) return;
    captureBundleKids(cart);
    var visible = cart.items.filter(function (i) { return !/ship_protect/i.test(i.product_type || ''); });
    itemsEl.innerHTML = visible.length ? visible.map(itemHTML).join('')
      : (pendingAdd ? '<p class="tu-cart__empty">Adding to cart…</p>' : '<p class="tu-cart__empty">Your cart is empty.</p>');
    var sub = productSubtotal();
    if (subtotalEl) subtotalEl.textContent = money(sub);
    renderRewards(sub);
    renderProtection(sub);
    updateCount(cart.item_count);
    renderFBT(visible);
    ensureInventoryFor(visible);
  }

  var TAG_SVG = '<svg class="tu-cart__deal-ico" viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><circle cx="7" cy="7" r="1.2" fill="currentColor" stroke="none"/></svg>';
  function itemHTML(i) {
    var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
    var max = lineMax(i);
    var atMax = (max != null && i.quantity >= max);
    // Bundle/discounted line: show each discount as a tag (title from line.discounts) + a struck-through
    // original price followed by the discounted price (matches Kaching's bundle display).
    var deals = (i.discounts || []).map(function (d) { return '<span class="tu-cart__item-deal">' + TAG_SVG + esc(d.title) + '</span>'; }).join('');
    // Price each line by its OWN actual price — Kaching's cart-transform settles each component's discounted
    // price into its cart line, so a mixed bundle shows real per-item values (a $40 tote stays $40). We do NOT
    // use the deal-bar prices for bundle lines: those are the WHOLE-bundle total, which is wrong on a per-line
    // basis — showing it on every line doubled a 2-set, and splitting it equally mispriced unequal items
    // (the $40 tote read as half the bundle). Strikethrough = the component variant's own RRP (the bundle
    // line's own compare_at is null), falling back to the line's regular price.
    var isBundleLine = !!(i.properties && i.properties.__kaching_bundles);
    var kids = mergedBundleKids(i);   // child product titles for a MERGED bundle line (empty otherwise)
    var nowCents = i.final_price;
    // A bundle can land as ONE merged line (e.g. a fixed "2-set" — final_price is the COMBINED deal, so the
    // strikethrough must be the COMBINED RRP from the deal bar) OR as separate component lines. Component lines
    // ALSO carry a __kaching_bundles property but with NO resolvable `bar`, so kbPrices() returns null for them —
    // we must NOT fall back to their regular price there; they need their OWN variant RRP (compare-at) like any
    // normal line. So only take the combined-RRP path when kbPrices() actually resolves a deal-bar price.
    var kb = (isBundleLine && bundleLineCount(i) <= 1) ? kbPrices(i) : null;
    var compareCents;
    if (kb && kb.compare) {
      compareCents = kb.compare;                          // merged single-line bundle → COMBINED RRP
    } else {
      // Component line of a multi-line bundle, OR a normal line → this variant's own RRP (compare-at price),
      // falling back to the regular price when a line is discounted but has no RRP set.
      var vc = variantCompare(i);
      compareCents = (vc > nowCents ? vc : 0) || (i.price > nowCents ? i.price : 0) || nowCents;
    }
    var discounted = compareCents > nowCents;
    var priceHTML = discounted
      ? '<s class="tu-cart__item-was">' + money(compareCents) + '</s> <span class="tu-cart__item-now">' + money(nowCents) + '</span>'
      : money(nowCents);
    return '<div class="tu-cart__item' + (atMax ? ' is-max' : '') + '" data-tu-key="' + i.key + '">'
      + (img ? '<img class="tu-cart__item-img" src="' + img + '" alt="" width="60" height="60" loading="lazy">' : '<span class="tu-cart__item-img"></span>')
      + '<div class="tu-cart__item-info">'
      +   '<a class="tu-cart__item-title" href="' + i.url + '">' + esc(i.product_title) + '</a>'
      +   (i.variant_title ? '<div class="tu-cart__item-variant">' + esc(i.variant_title) + '</div>' : '')
      +   (kids.length ? '<ul class="tu-cart__item-kids">' + kids.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' : '')
      +   (deals ? '<div class="tu-cart__item-deals">' + deals + '</div>' : '')
      +   '<div class="tu-cart__item-price">' + priceHTML + '</div>'
      +   (isPreorder(i) ? '<div class="tu-cart__item-preorder">Preorder &ndash; more coming</div>' : (atMax ? '<div class="tu-cart__item-stock">Only ' + max + ' left</div>' : ''))
      + '</div>'
      + '<div class="tu-cart__item-controls">'
      // Optimistic placeholder line has no real key yet → disable edits until the server line lands (~instantly→3.5s).
      +   '<button class="tu-cart__remove" data-tu-act="remove" aria-label="Remove item"' + (i.__pending ? ' disabled' : '') + '>&#10005;</button>'
      +   '<div class="tu-cart__qty">'
      +     '<button data-tu-act="dec" aria-label="Decrease quantity"' + (i.__pending ? ' disabled' : '') + '>&minus;</button>'
      +     '<span class="tu-cart__qty-val">' + i.quantity + '</span>'
      +     '<button data-tu-act="inc" aria-label="Increase quantity"' + (atMax || i.__pending ? ' disabled' : '') + '>+</button>'
      +   '</div>'
      + '</div></div>';
  }

  // Smooth proportional fill: interpolates between milestone positions.
  function fillPos(sub) {
    if (sub <= 0) return 0;
    var last = FILL_PTS[FILL_PTS.length - 1];
    if (sub >= last[0]) return last[1];
    for (var i = 1; i < FILL_PTS.length; i++) {
      if (sub < FILL_PTS[i][0]) {
        var p0 = FILL_PTS[i - 1], p1 = FILL_PTS[i];
        return p0[1] + (sub - p0[0]) / (p1[0] - p0[0]) * (p1[1] - p0[1]);
      }
    }
    return last[1];
  }

  // Goal ladder for messaging = GOAL_DEFS, dropping free-ship for non-AU (NZ/ROW still earn credits).
  function goalLadder() { return GOAL_DEFS.filter(function (g) { return FREE_SHIP_OK || !g.fs; }); }
  // Locked template: replace {{amount}} with the bolded remaining spend.
  function lockedMsg(g, amt) { return String(g.locked).replace(/\{\{\s*amount\s*\}\}/g, '<strong>' + money(amt) + '</strong>'); }

  function renderRewards(sub) {
    if (HIDE_GOALS) return;   // country override hides the goals/rewards bar entirely
    var G = goalLadder();
    var next = null, achieved = null;
    for (var i = 0; i < G.length; i++) { if (sub < G[i].at) { next = G[i]; break; } }
    for (var j = G.length - 1; j >= 0; j--) { if (sub >= G[j].at) { achieved = G[j]; break; } }

    // Highest credit tier's tooltip — used for the "earned the maximum" message.
    var creditGoals = G.filter(function (g) { return !g.fs && g.tooltip; });
    var maxTip = creditGoals.length ? creditGoals[creditGoals.length - 1].tooltip : '';

    // TOP of cart = the NEXT goal to be achieved (locked template). ⓘ icon when it's a credit goal.
    if (fsMsgEl) {
      fsMsgEl.style.display = '';
      fsMsgEl.innerHTML = next
        ? lockedMsg(next, next.at - sub) + (next.fs ? '' : infoHTML(next.tooltip))
        : MAX_MSG + infoHTML(maxTip);
    }

    if (barFill) barFill.style.width = fillPos(sub) + '%';
    markers.forEach(function (m) { m.classList.toggle('is-reached', sub >= +m.getAttribute('data-tu-at')); });

    // ABOVE SUBTOTAL = the HIGHEST goal achieved to date (unlocked message); ⓘ when it's a credit goal.
    if (creditMsgEl) {
      if (achieved) { creditMsgEl.style.display = ''; creditMsgEl.innerHTML = achieved.unlocked + (achieved.fs ? '' : infoHTML(achieved.tooltip)); }
      else { creditMsgEl.style.display = 'none'; creditMsgEl.innerHTML = ''; }
    }
  }

  // Frequently Bought Together — Shopify ML recommendations (intent=related, matches Monster).
  function renderFBT(visible) {
    if (!fbtEl) return;
    if (!visible.length) { fbtEl.hidden = true; fbtBody.innerHTML = ''; lastFbtSig = null; return; }
    var sig = cart.items.map(function (i) { return i.product_id; }).sort().join(',');
    if (sig === lastFbtSig) return;
    lastFbtSig = sig;
    var anchor = visible[0];
    var inCart = cart.items.map(function (i) { return i.product_id; });
    fetch('/recommendations/products.json?product_id=' + anchor.product_id + '&intent=related&limit=10', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rec = (d.products || []).filter(function (p) {
          if (inCart.indexOf(p.id) !== -1) return false;
          if (/ship_protect/i.test(p.type || '')) return false;
          if ((p.tags || []).some(function (t) { return /hide_recommender/i.test(String(t)); })) return false;
          return p.available;
        })[0];
        var v = rec && ((rec.variants || []).filter(function (x) { return x.available; })[0] || (rec.variants || [])[0]);
        if (!rec || !v) { fbtEl.hidden = true; return; }
        fbtBody.innerHTML = fbtHTML(rec, v);
        fbtEl.hidden = false;
      })
      .catch(function () { fbtEl.hidden = true; });
  }

  function fbtHTML(p, v) {
    var img = p.featured_image || '';
    if (img) { if (img.indexOf('//') === 0) img = 'https:' + img; img = img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2'); }
    var cmp = v.compare_at_price, price = v.price;
    var priceHtml = (cmp && cmp > price)
      ? '<s class="tu-cart__fbt-was">' + money(cmp) + '</s> <span class="tu-cart__fbt-now">' + money(price) + '</span>'
      : '<span class="tu-cart__fbt-now">' + money(price) + '</span>';
    return '<div class="tu-cart__fbt-item">'
      + (img ? '<img class="tu-cart__fbt-img" src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '<span class="tu-cart__fbt-img"></span>')
      + '<div class="tu-cart__fbt-info">'
      +   '<a class="tu-cart__fbt-title" href="' + (p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>'
      +   '<div class="tu-cart__fbt-price">' + priceHtml + '</div>'
      + '</div>'
      + '<button type="button" class="tu-cart__fbt-add" data-tu-add="' + v.id + '">Add To Cart</button>'
      + '</div>';
  }

  // --- Shipping protection (Option B). Fee VERIFIED vs ShipProtect: round(subtotal*1.5%) to nearest $,
  // land on x.99, min $2.99, cap $100.99. Pre-checked toggle; main button adds it unless unchecked.
  function loadProtMap() {
    return fetch('/products/' + PROT_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { protMap = {}; (p.variants || []).forEach(function (v) { protMap[v.price] = v.id; }); protLoaded = true; })
      .catch(function () { protLoaded = false; });
  }
  function protFeeCents(subCents) {
    var dollars = Math.min(Math.max(Math.round((subCents / 100) * 0.015), 3), 101);
    return dollars * 100 - 1;
  }
  function renderProtection(sub) {
    if (!protRow) return;
    // Hide protection entirely if the cart has no real items (only protection lines, or empty).
    var hasItems = cart && cart.items.some(function (i) { return !/ship_protect/i.test(i.product_type || ''); });
    var vid = (hasItems && protLoaded && protMap) ? protMap[protFeeCents(sub)] : null;
    if (!vid) { root.classList.add('tu-cart--noprotect'); protRow.removeAttribute('data-tu-variant'); return; }
    root.classList.remove('tu-cart--noprotect');
    protRow.setAttribute('data-tu-variant', vid);
    if (protPriceEl) protPriceEl.textContent = money(protFeeCents(sub)) + ' ' + CURR;
  }
  function goCheckout(withProtection) {
    root.classList.add('tu-cart--busy');
    checkingOut = true;               // lock the overlay on — no concurrent add/settle may clear it
    showLoader('Loading checkout…');  // the checkout page is slow to load — keep the overlay until we navigate
    var removals = (cart ? cart.items : []).filter(function (i) { return /ship_protect/i.test(i.product_type || ''); }).map(function (i) { return i.key; });
    var chain = Promise.resolve();
    removals.forEach(function (k) { chain = chain.then(function () { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: k, quantity: 0 }) }); }); });
    chain.then(function () {
      if (!withProtection) return null;
      return fetchCart().then(function () {
        var vid = protMap ? protMap[protFeeCents(productSubtotal())] : null;
        return vid ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) }) : null;
      });
    }).then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = '/checkout'; });
  }

  function updateCount(n) {
    n = n || 0;
    document.querySelectorAll('.tu-cart-count').forEach(function (s) { s.textContent = n; });
    var bubbles = document.querySelectorAll('.cart-count-bubble');
    if (n <= 0) {
      // Empty cart → Dawn renders NO bubble at all. Remove ours so the nav badge actually disappears
      // (just blanking the number left a stale green dot showing "0"/"1").
      bubbles.forEach(function (b) { if (b.parentNode) b.parentNode.removeChild(b); });
      return;
    }
    if (bubbles.length) {
      bubbles.forEach(function (b) {
        var v = b.querySelector('span[aria-hidden="true"]'); if (v) v.textContent = n;
        var h = b.querySelector('.visually-hidden'); if (h) h.textContent = n + (n === 1 ? ' item' : ' items');
        b.style.display = '';
      });
    } else {
      // Cart was empty on page load (Dawn rendered no bubble) → build one so the badge appears on first add.
      var icon = document.getElementById('cart-icon-bubble');
      if (icon) {
        var d = document.createElement('div');
        d.className = 'cart-count-bubble';
        d.innerHTML = '<span aria-hidden="true">' + n + '</span><span class="visually-hidden">' + n + (n === 1 ? ' item' : ' items') + '</span>';
        icon.appendChild(d);
      }
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
